import React from 'react';

import { TenantSettingKey } from '@recurrency/core-api-schema/dist/common/tenantSettings';

import { Tooltip } from 'components/Tooltip';

import { formatLocationLabel } from 'utils/formatting';
import { getTenantSetting } from 'utils/tenantSettings';

export function LocationLabel({ value }: { value?: string }) {
  const idOnly = getTenantSetting(TenantSettingKey.UiShowLocationIdOnly) ?? false;
  const label = formatLocationLabel(value, idOnly);

  if (!value || !idOnly || label === value) {
    return <>{label}</>;
  }

  return (
    <Tooltip title={value}>
      <span>{label}</span>
    </Tooltip>
  );
}
